<template>
    <div class="connect">
      <template v-if="!isAuthenticated">
        <div class="login-section">
          <form @submit.prevent="submitRecovery" class="compact-form">
            <div class="input-group" v-if="!emailAddress">
              <label for="email" class="input-label">Email</label>
              <input v-model="email" type="text" class="input-control" id="email" placeholder="Veuillez renseignez votre email" autocomplete="email">
            </div>
            <FriendlyCaptcha
                :sitekey="sitekey"
                data-start="auto"
                language="fr"
                @done="onCaptchaDone"
                @error="onCaptchaError"
                />
            <!-- <div class="input-group">
                <label for="password" class="input-label">Mot de passe</label>
                <div class="password-wrapper">
                    <input v-if="showPassword" v-model="password" type="text" class="input-control" id="password" placeholder="Mot de passe" autocomplete="current-password">
                    <input v-else v-model="password" type="password" class="input-control" id="password" placeholder="Mot de passe" autocomplete="current-password">
                    <div @click="toggleShow" class="eye-icon">
                        <i class="bi" :class="{ 'bi-eye-slash-fill': showPassword, 'bi-eye-fill': !showPassword }"></i>
                    </div>
                </div>
            </div> -->
  
            <!-- <div class="input-group" v-else>
                Veuillez consulter votre boîte mail et cliquer sur le nouveau lien pour mettre à jour votre mot de passe
            </div> -->
            <div class="register-link">
                <div class="form-footer">
                    <button type="submit">Envoyer</button>
                    <button @click="this.$router.push(`/login`)" class="back-button">Retour</button>
                </div>
            </div>
          </form>
        </div>
      </template>
    </div>
</template>
  
  <script>
  import { mapState } from 'vuex';
  import '../../assets/styles/modal.css'
  import '../../assets/styles/base.css'
  import FriendlyCaptcha from "@/components/auth/FriendlyCaptcha.vue"
  
  export default {
    name: "ForgotPassword",
    components:{
    FriendlyCaptcha
    },
    data() {
      return {
        email: "",
        password: "",
        showPassword: false,
        emailAddress:"",
        sitekey:(window.__APP_CONFIG__?.VUE_APP_CAPTCHA || process.env.VUE_APP_CAPTCHA),
        /* captchaToken: null, */
      }
    },
    computed: {
      ...mapState('auth', ['isAuthenticated', 'user', 'respStatus', 'emailState']),
    },
    methods: {
      async submitRecovery() {
        const token = document.querySelector('[name="frc-captcha-solution"]')?.value
        //console.log("this.email :",this.email, "\ncaptcha :", token)
        if (!this.email || this.email.length === 0) {
          alert("Veuillez entrer votre email");
          return;
        }
        
        /* if (!this.captchaToken) {
          alert("Veuillez compléter le captcha ", this.captchaToken);
          return;
        } */

        try {
          const payload = { email: this.email, token: token };
          //console.log("Submitting payload:", payload);
          await this.$store.dispatch("auth/passwordRecovery", payload);
          //console.log("Response:", response);
          alert("Email de récupération envoyé avec succès!");
          this.$router.back();
        } catch (error) {
          console.error("Error:", error || "pas trouvé le message d'erreur");
          alert("Erreur:" + error || "inconnue");
        }
      },
       toggleShow() {
        this.showPassword = !this.showPassword;
      },

      // eslint-disable-next-line no-unused-vars
      onCaptchaDone(token) {
        /* this.captchaToken = token */
        //console.log("TOKEN VALUE:", token);
      },

      onCaptchaError(error) {
        console.error("Erreur Captcha :", error);
        /* this.captchaToken = null; */
        alert("Erreur du captcha, veuillez réessayer.");
      },

    },
  };
  </script>
  
  <style scoped>
   .welcome {
    padding: 20px 0px 10px;
    margin: 10px auto;
    text-align: center;
    border-bottom: #e5e5e54a 1px solid;
  }

  .connect {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }
  
  .login-section {
    max-width: 450px;
    width: 100%;
  }
  
  .compact-form {
    padding: 14px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(255, 172, 172, 0.5);
    margin-bottom: 16px;
  }
  
  .input-group {
    margin-bottom: 16px;
  }
  
  .input-label {
    font-weight: 600;
    font-size: 0.9rem;
    display: block;
    margin-bottom: 4px;
    color: #2c3e50;
  }
  
  .input-control {
    width: 100%;
    padding: 8px 12px;
    font-size: 0.9rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: rgba(245, 245, 245, 0.031);
  }

  .password-wrapper {
    position: relative;
    display: flex;
  }

  .password-wrapper .input-control {
    flex: 1;
    padding-right: 40px;
  }

  .eye-icon {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .bi {
    font-size: 1rem;
    color: var(--text-color);
    padding: 0 12px;
  }
  
  .form-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
  }

  button{
    padding: 1vh 1.75vw;
  }
  
/*   a {
    color: var(--primary-color);
    text-decoration: none;
    transition: all 0.3s ease;
    margin: 8px 0 0 75px;
    text-align: center;
  }
  
  a:hover {
    color: var(--primary-color);
    text-decoration: underline;
  } */

  .register-link {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 16px 75px 0 0;
  }

  </style>